import gql from 'graphql-tag';
import ClientCommon from './client';
import ClientDisclosure from './client_disclosure';

export default gql`
  fragment ClientProtected on Client {
    created_at
    email_from_address
    allow_user_invites
    content_domains
    allow_group_creation
    disable_comments
    disable_timeline
    email_address
    sso_provider
    allow_sharing
    compliance_notification_emails
    compliance_notification_enabled
    stickers {
      bucket
      key
      width
      height
    }
    stickers_enabled
    features
    disclosures {
      ...ClientDisclosure
    }
    social_config {
      twitter_shareable
      twitter_engageable
      linkedin_shareable
      linkedin_engageable
      facebook_shareable
      facebook_engageable
      youtube_shareable
      youtube_engageable
      instagram_shareable
      instagram_engageable
    }
    disclosures {
      id
      disclosure
    }
    ...ClientCommon
  }
  ${ClientCommon}
  ${ClientDisclosure}
`;
